import { useTranslation } from 'react-i18next';
import { getLicenseVisualStatus } from 'shared-ui/lib/utils/license-status';

type Props = {
  licenseStatus: string;
  licenseExpireDate?: string | Date | null;
};

const classNames = (...classes: string[]) => {
  return classes.filter((x) => x).join(' ');
};

export const LicenseBadge = ({ licenseStatus, licenseExpireDate }: Props) => {
  const { t } = useTranslation('LicenseStatus');
  const classes = 'float-right text-xs font-medium';

  const licenseInfo = getLicenseVisualStatus({
    licenseStatus,
    licenseExpireDate,
  });

  if (licenseInfo.level === 'GREEN') {
    return null;
  }

  let colorClass = 'bg-green-600 text-white';

  if (licenseInfo.level === 'NO_ACTIVE') {
    colorClass = 'bg-gray-500 text-white';
  } else if (licenseInfo.level === 'RED') {
    colorClass = 'bg-red-600 text-white';
  } else if (licenseInfo.level === 'ORANGE') {
    colorClass = 'bg-orange-color text-white';
  } else if (licenseInfo.level === 'YELLOW') {
    colorClass = 'bg-yellow-500 text-white';
  }

  const text =
    licenseInfo.level === 'NO_ACTIVE' || licenseInfo.daysLeft === null
      ? t('NO_ACTIVE')
      : t('ACTIVE_DAYS', { count: licenseInfo.daysLeft });

  return <span style={{ margin: '0 0 0 auto' }} className={classNames(classes, `${colorClass} py-1 px-2 rounded-full w-fit`)}>{text}</span>;
};
